export const navLinks = [
  { label: "분석", href: "#reports", tKey: "nav_analysis" },
  { label: "엔진", href: "#categories", tKey: "nav_engines" },
  { label: "논문", href: "#papers", tKey: "nav_papers" },
  { label: "연구소", href: "#about", tKey: "nav_institute" },
];

export const heroStats = [
  { value: "206", label: "개국 분석" },
  { value: "965,913", label: "ACLED 이벤트" },
  { value: "A0–A12", label: "사회구조 설계공리" },
  { value: "2", label: "SSRN 등재 논문" },
];

export const tickerItems = [
  "합계출산율 0.72 · 통계청 2025",
  "청년실업률 5.9% · KOSIS 2025",
  "1인 가구 비중 34.5% · 통계청",
  "실질임금 상승률 +1.8% · 고용노동부",
  "고령화율 19.7% · 행정안전부",
  "글로벌 CPI +2.4% · OECD 2025",
  "KOSPI 서킷브레이커 2025-06-23",
  "XAU/USD $3,941 · 2026-07-03",
  "한국 BSLI C등급 0.4627 · EBS 2026",
  "미국 UI −0.785 · REVERBANT 2026",
  "ACLED 글로벌 시위 965,913건 · 2026",
  "이란 2026 취성파괴 경보 · REVERBANT",
];

/* ══════════════════════════════════════════════════════════════════════════
   최신 분석 카드 — 자동 정렬·자동 밀어내기 체계 (2026-07-26 도입)
   ──────────────────────────────────────────────────────────────────────────
   ★ 새 보고서 추가 방법: 아래 featuredReports 배열에 항목 1개 추가만 하면 끝.
     - 위치는 아무 데나 넣어도 된다. date 기준으로 자동 정렬된다.
     - 카드가 FEATURED_MAX(5)개를 넘으면 가장 오래된 것이 자동으로 화면에서 빠진다.
       (배열에서 지우지 않아도 된다 — 데이터는 남고 노출만 밀려난다.
        /reports/{id} 직접 링크는 계속 살아 있다.)
     - pinned: true 를 붙인 항목은 날짜와 무관하게 항상 최상단에 고정된다.
       고정 항목이 여러 개면 그들끼리는 date 내림차순으로 정렬된다.
       현재 고정 2개 (2026-07-27 확정 — 2026 하반기 업데이트 때까지 유지):
         · r-007 Λ¹²·BSLI 통합 국가분석 정본 (138국 전수)
         · r-009 BSLI 2026 상반기 시계열 정본 (137국)
       두 정본은 하반기판이 나오면 **새 항목을 만들지 않고 이 두 항목을 갱신**한다.
       (그래야 고정 슬롯이 늘어나 최신분석 5칸을 잠식하지 않는다.)

   ★ 오피니언 전용 칸 (2026-10-08 도입): opinion: true 항목은 분석 5칸과 별도로
     맨 아래 1칸(FEATURED_OPINION_MAX)에 최신 칼럼 1편만 노출된다. 총 6칸 운영.

   ★ 배포 전 필수 확인 2가지
     - public/images/cards/r-NNN.svg 존재 (Unsplash URL 금지 — 캐시 깨짐 이력)
     - public/reports/r-NNN.json 존재 (없으면 카드 클릭 시 404)

   ★ 이 파일 수정 시 반드시 giseu 최신본 pull 후 작업 (다운로드 구파일 덮어쓰기 금지)
   ══════════════════════════════════════════════════════════════════════════ */

/** 홈 최신분석 섹션에 동시에 노출할 분석 카드 최대 개수 (오피니언 칸 제외) */
export const FEATURED_MAX = 5;

/** 최신분석 섹션의 오피니언 전용 칸 수 — 분석 5칸 + 오피니언 1칸 = 총 6칸 (2026-10-08 청해 지시)
 *  opinion: true 항목만 이 칸에 들어가며, 분석 5칸의 자동 밀어내기와 서로 간섭하지 않는다. */
export const FEATURED_OPINION_MAX = 1;

export type FeaturedReport = {
  id: string;
  category: string;
  categoryEn?: string;
  date: string;
  author: string;
  title: string;
  titleEn?: string;
  excerpt: string;
  excerptEn?: string;
  image: string;
  tone: "light" | "dark";
  /** true면 날짜와 무관하게 항상 최상단 고정 (버전업 전까지 유지) */
  pinned?: boolean;
  /** true면 오피니언 전용 칸에 노출 (분석 5칸 집계에서 제외) */
  opinion?: boolean;
};

export const featuredReports: FeaturedReport[] = [
  {
    id: "r-024",
    category: "오피니언 · 보고서",
    categoryEn: "Opinion · Report",
    date: "2026-10-25",
    author: "청해",
    title: "같은 불씨, 다른 불길: 트리거는 왜 임계점에서 터지나",
    titleEn: "Same Spark, Different Fires: Why Triggers Ignite at the Threshold",
    excerpt: "2023년 낭테르의 나엘 사건은 프랑스 전역을 태웠고, 2020년 배달기사 슈비아의 죽음은 거리를 거의 움직이지 못했다. 같은 불씨가 왜 어떤 때만 큰불이 되는가. 유럽 시위·폭동 82건과 번지지 않은 42건을 나란히 놓으니, 트리거의 크기도 연간 사회 지표도 갈림길을 가르지 못했다. 되풀이해 보인 것은 진행 중인 같은 쟁점의 운동, 당국 대응이 만든 두 번째 불씨, 부패·은폐로 이어진 참사, 노조의 선택이었다. 무질서 뒤에 '질서' 정당이 표를 얻는다는 일반 규칙은 유럽 25개 캠페인에서 확인되지 않았다.",
    excerptEn: "The 2023 killing of Nahel in Nanterre set France alight, while the 2020 death of delivery rider Cédric Chouviat barely moved the streets. Why does the same spark become a blaze only sometimes? Setting 82 European protests and riots beside 42 triggers that did not spread, neither the size of the trigger nor annual social indicators separated the two. What recurred was an ongoing campaign on the same issue, a second spark created by the authorities' response, disasters tied to corruption or cover-up, and the choice unions made. Across 25 European campaigns, no general rule that disorder hands votes to 'law and order' parties was confirmed.",
    image: "/images/cards/r-024.svg",
    tone: "dark" as const,
    opinion: true, // ★ 오피니언 전용 칸 — 최신 칼럼 1편 노출(r-023은 오피니언 목록에 유지)
  },
  {
    id: "r-023",
    category: "오피니언 · 청해 칼럼",
    categoryEn: "Opinion · Cheonghae Column",
    date: "2026-10-24",
    author: "청해",
    title: "군대가 거리로 나올 때 — 경찰은 치안을 맡고 군대는 무력을 쓴다",
    titleEn: "When the Army Comes onto the Streets — The Police Keep Order; the Army Uses Force",
    excerpt: "2026년 가을 이탈리아는 밀라노에 공수부대 500명을, 프랑스는 상티넬 작전 병력을 시설 경비에 돌렸다. 근대 유럽이 거리에서 군대를 빼려고 경찰을 만든 지 200년 만이다. 중세 반란부터 2026년까지 약탈 32건, 체포된 사람의 구성과 이민 시계열, 축구장에 남은 오래된 갈등을 자료로 따라가고 묻는다 — 약탈은 서민이 서민에게 무력을 행사하는 것이 아닌가.",
    excerptEn: "In autumn 2026 Italy sent 500 paratroopers to Milan and France moved Operation Sentinelle troops to guard key sites — two centuries after modern Europe created police to take the army off the streets. Tracing 32 cases of looting from medieval revolts to 2026, the make-up of those arrested against migration trends, and the old grudges carried into football grounds, the column asks: is looting not ordinary people using force against ordinary people?",
    image: "/images/cards/r-023.svg",
    tone: "dark" as const,
    opinion: true, // ★ 오피니언 전용 칸 — 최신 칼럼 1편 노출(r-018은 오피니언 목록에 유지)
  },
  {
    id: "r-022",
    category: "봉기지수 · 세계 관찰",
    categoryEn: "Uprising Index · World Watch",
    date: "2026-10-23",
    author: "김기섭",
    title: "번외편 — 유럽 시위 현장 일지",
    titleEn: "Special Edition — European Protest Field Log",
    excerpt: "「유럽 시위의 번짐」의 번외편이다. 본편을 일곱 줄로 요약한 뒤, 그 아래에 날마다의 현장 기록을 서브 문서로 하나씩 더한다. 14개 나라의 영어·현지어 뉴스와 영문 위키백과를 매일 모아 시위·파업·봉쇄·충돌을 사건 단위로 묶고, 규모는 누가 셌는지(주최 측·경찰·언론)를 붙인다. 해석은 하지 않는다 — 날마다 쌓이는 사건 수·폭동·체포·정부 대응의 누적 표가 그대로 다음 분석의 데이터가 된다. 매일 갱신.",
    excerptEn: "A special edition of 'The Spread of Protest in Europe'. It summarises the main report in seven points, then adds each day's field record below as a sub-document. Every day it gathers English and local-language news from 14 countries and English Wikipedia, groups protests, strikes, blockades and clashes event by event, and attributes every count to whoever made it (organisers, police, media). No interpretation — the cumulative table of events, riots, arrests and government responses that grows day by day is itself the data for the next analysis. Updated daily.",
    image: "/images/cards/r-022.svg",
    tone: "dark" as const,
  },
  {
    id: "r-021",
    category: "봉기지수 · 세계 관찰",
    categoryEn: "Uprising Index · World Watch",
    date: "2026-10-23",
    author: "김기섭",
    title: "유럽 시위의 번짐 — 진원지, 전이, 폭동, 재발",
    titleEn: "The Spread of Protest in Europe — Epicentre, Contagion, Riots, Recurrence",
    excerpt: "2026년 가을 유럽 시위는 프랑스(9/30 점화)를 진원지로 벨기에·이탈리아·포르투갈로 번졌다. 번진 곳을 가른 것은 고부채·고이자의 체질(AUC 0.94)과 같은 언어권(0.93)이었고, 연료가 더 많은 그리스와 신뢰가 더 떨어진 독일로는 10월 셋째 주까지 번지지 않았다. 43개 캠페인 가운데 폭동까지 간 5개는 모두 청년·학생 주도였고 모두 탄압과 만났다. 2010~25년 정책을 철회한 경우 2년 안 재발은 0/6, 강행한 경우 7/12. 국가의 결정이 생활비로 내려오고 목소리를 낼 통로가 막힐 때 청년이 먼저 나온다 — 일자별 변화 기록과 함께, 무장 분쟁의 동남아와 무엇이 다른지 묻는다.",
    excerptEn: "Europe's autumn 2026 protests spread from their epicentre in France (ignited 30 September) to Belgium, Italy and Portugal. What separated the countries they reached was a high-debt, high-interest fiscal profile (AUC 0.94) and a shared language area (0.93); through the third week of October they did not reach Greece, with more fuel, or Germany, with lower trust. Of 43 campaigns, all five that turned into riots were led by young people and students, and all met repression. In 2010–25, campaigns whose policy was withdrawn did not recur within two years (0/6), while those pushed through recurred in 7 of 12. When state decisions land on the cost of living and the channels to object are blocked, the young move first — with a day-by-day change log, the report asks how this differs from Southeast Asia's armed conflicts.",
    image: "/images/cards/r-021.svg",
    tone: "dark" as const,
  },
  {
    id: "r-020",
    category: "봉기지수 · 세계 관찰",
    categoryEn: "Uprising Index · World Watch",
    date: "2026-10-23",
    author: "김기섭",
    title: "동남아시아의 분쟁 — 지정학 전체와 국가별 기록",
    titleEn: "Conflicts in Southeast Asia — The Regional Geopolitics and Country-by-Country Records",
    excerpt: "동남아 11개국에서 지금 무력 충돌이 실제로 진행 중인 곳은 미얀마·태국 남부·필리핀·인도네시아 파푸아 네 곳이다. 미얀마 내전은 누적 사망 약 10만 명, 실향 약 380만 명에 이르렀고, 태국과 캄보디아는 2025년 전투기를 띄운 국가 간 교전 뒤 불안정한 휴전에 있다. 분쟁은 세 판 — 대륙부 내전·국경, 도서부 분리·반군, 남중국해 — 위에서 벌어지고, 중국은 그 셋 모두에서 중재자·투자자·당사국으로 서 있다. 뿌리는 국가 형성기에 정리되지 않은 경계와 소속이다. 14개 분쟁을 나라별로 따로 기록하고, 마지막에 묻는다 — 시위의 유럽과 무장 분쟁의 동남아는 무엇이 다른가.",
    excerptEn: "Of Southeast Asia's 11 countries, armed conflict is actively under way in four: Myanmar, southern Thailand, the Philippines and Indonesia's Papua. Myanmar's civil war has left some 100,000 dead and about 3.8 million displaced, and Thailand and Cambodia sit in an unstable ceasefire after a 2025 interstate clash in which fighter jets flew. The conflicts unfold on three arenas — mainland civil war and borders, insular separatism and insurgency, and the South China Sea — and China stands in all three as mediator, investor and party. The roots are borders and belonging left unsettled when the states were formed. The report records 14 conflicts country by country and ends by asking how Europe's protests differ from Southeast Asia's armed conflicts.",
    image: "/images/cards/r-020.svg",
    tone: "dark" as const,
  },
  {
    id: "r-019",
    category: "봉기지수 · 세계 관찰",
    categoryEn: "Uprising Index · World Watch",
    date: "2026-10-21",
    author: "김기섭",
    title: "유럽의 재정 악화 분석 — 전쟁은 서민을 어떻게 갉아먹는가",
    titleEn: "Analysis of Europe's Fiscal Deterioration — How War Wears Down Ordinary People",
    excerpt: "2026년 가을 유럽 시위는 우크라이나 원조 때문이 아니었다. 원조는 연 GDP의 0.04~0.14%였고, 서민을 친 것은 달러로 매겨진 기름값과, 재무장·이자에 자리를 내준 학교·복지 예산이었다. 끊긴 러시아 가스로 난방을 못 하는 사람은 프랑스에서 두 배가 되었고, 전쟁 연관 비용은 누적 적자의 3분의 1(독일 3분의 2)에 이르렀다. 전쟁의 뿌리·멈추지 않는 이유·우크라이나의 부패와 EU 가입·돈바스 자치구 구상까지 지정학으로 거슬러 오르고, 번외편에서 34개국을 비교해 묻는다 — 유럽형 선진국 모델은 실패인가, 자정 중인가.",
    excerptEn: "The autumn 2026 protests in Europe were not caused by aid to Ukraine, which ran at 0.04–0.14% of GDP a year; ordinary people were hit by dollar-priced fuel and by school and welfare budgets displaced by rearmament and interest. With Russian gas cut off, the share of French people unable to heat their homes doubled, and war-linked costs reached a third of cumulative deficits (two-thirds in Germany). The report traces the geopolitics back to the roots of the war, why it does not stop, Ukraine's corruption and EU accession, and the idea of a Donbas autonomous zone, and in a special section compares 34 countries to ask: is the European advanced-economy model failing, or self-correcting?",
    image: "/images/cards/r-019.svg",
    tone: "dark" as const,
  },
  {
    id: "r-018",
    category: "오피니언 · 청해 칼럼",
    categoryEn: "Opinion · Cheonghae Column",
    date: "2026-10-20",
    author: "청해",
    title: "달콤함의 대가 — 국민이 권력자를 섬기듯, 권력자도 같은 값을 치러야 한다",
    titleEn: "The Price of Sweetness — As the People Serve Those in Power, Those in Power Must Pay the Same Price",
    excerpt: "기득권(정치·제도·자본)의 일탈이 서민의 의식과 멀어질수록 그 달콤함은 반드시 큰 대가를 치르게 하고, 사회의 혼란은 막을 수 없게 된다. 통치자 네 명 중 한 명은 안에서 무너졌고, 2024~25년 청년 세대는 정치인 자녀의 사치 사진 한 장에 정부를 무너뜨렸다. 절제된 나라 부탄은 권력이 제도와 정책을 서민의 생활까지 내려보낼 때 오래간다는 것을 보여 준다. 1차 연구가 세운 개념과 공리 A0~A12·P0~P10을 함께 정리했다.",
    excerptEn: "The further the deviance of the establishment — political, institutional and financial — drifts from the consciousness of ordinary people, the greater the price its sweetness exacts, until social turmoil can no longer be prevented. One ruler in four fell from within, and in 2024–25 a young generation brought down governments over a single photograph of politicians' children flaunting luxury. Bhutan, the restrained nation, shows that power lasts when it carries institutions and policies down to the lives of ordinary people. The column also sets out the concepts and axioms A0–A12 and P0–P10 established by the first phase of research.",
    image: "/images/cards/r-018.svg",
    tone: "dark" as const,
    opinion: true, // ★ 오피니언 전용 칸 — 최신 칼럼 1편 노출(r-015는 오피니언 목록에 유지)
  },
  {
    id: "r-017",
    category: "통합 논문 · 담론육층",
    categoryEn: "Integrated Paper · Six-Layer Discourse",
    date: "2026-10-20",
    author: "김기섭",
    title: "민중의 튼튼함과 국가의 흡수력 — 통합 논문 v1",
    titleEn: "The Robustness of the People and the Absorptive Capacity of the State — Integrated Paper v1",
    excerpt: "홈페이지 보고서 415편을 담론육층사유법의 순서로 엮은 첫 통합 논문이다. 민중의 튼튼함(BSLI)이 받쳐 주지 않는 나라에서 지도층 부패(ρ −0.59)·해외 이탈·정치폭력이 함께 나타나고, 청년 세대 봉기는 위험 상위가 아니라 중위권·중진국에서 일어났다. 197개국을 위키백과 기준 통치 형태와 발전 단계로 나누어 운영·생활·전망·재건의 지렛대를 비교하고, 2024~2026 세계 반정부 대중운동 45건과 2026년 가을 유럽 소요에서 세 개의 물결과 공통 구조를 찾았다. 모든 유형에 공통인 위험을 낮추는 첫 지렛대는 지도자 곁의 기생을 끊는 것이다.",
    excerptEn: "The first integrated paper, weaving 415 reports on this site together in the order of the Six-Layer Discourse Method. Where the robustness of ordinary people (BSLI) does not hold, elite corruption (ρ −0.59), emigration and political violence appear together, and youth-led uprisings broke out not among the highest-risk states but in the middle ranks and in upper-middle-income countries. The paper compares 197 countries by form of government (classified per Wikipedia) and stage of development across operation, livelihood, prospects and levers for reconstruction, and finds three waves and a shared structure in 45 anti-government mass movements of 2024–2026 and the autumn 2026 European unrest. The first lever common to every type is cutting the parasites around the leader.",
    image: "/images/cards/r-017.svg",
    tone: "dark" as const,
  },
  {
    id: "r-016",
    category: "§37 PPI · 권력기생지수",
    categoryEn: "§37 PPI · Power Parasite Index",
    date: "2026-10-12",
    author: "김기섭",
    title: "권력기생지수(PPI) — 공리·역사 기준선·인과루프 포획틀",
    titleEn: "Power Parasite Index (PPI) — Axioms, Historical Baselines and the Capture Loop Framework",
    excerpt: "통치자 4명 중 1명은 내부 세력에 의해 끝났다 — 유럽 군주 재위 741건 중 25%, 중국 통치자 249명 중 25.3%. 권력기생지수를 공리 P0~P10으로 다시 세우고, Wikidata 통치자 전수조사 16,661건과 외부 검증 데이터(Archigos·Kokkonen·Wang), 현대 사례 226건으로 보강했다. 기생은 사라지지 않고 형태를 바꿨다 — 중세의 섭정·혈족·폐위에서 현대의 합법화·사면·국경을 넘는 지대로. 강화 루프 8개와 균형 루프 4개의 인과루프 포획틀을 제시하고, 통치자 356명의 서사를 기생 유형 9개로 묶은 별첨을 함께 싣는다.",
    excerptEn: "One ruler in four was ended by forces from within — 25% of 741 European royal reigns and 25.3% of 249 Chinese rulers. This report rebuilds the Power Parasite Index on axioms P0–P10 and reinforces it with a Wikidata census of 16,661 ruler terms, external validation data (Archigos, Kokkonen et al., Wang) and 226 contemporary cases. Parasitism did not disappear; it changed form — from regency, kinship and deposition in the Middle Ages to legalisation, pardons and cross-border rents today. It sets out a causal-loop capture framework of eight reinforcing and four balancing loops, with an appendix of narratives for 356 rulers grouped into nine types of parasitic relationship.",
    image: "/images/cards/r-016.svg",
    tone: "dark" as const,
  },
  {
    id: "r-015",
    category: "오피니언 · 청해 칼럼",
    categoryEn: "Opinion · Cheonghae Column",
    date: "2026-10-09",
    author: "청해",
    title: "세계의 굶주림에 대한 서사 — 끼니는 국력이 아니라 성실함의 문제다",
    titleEn: "A Narrative of the World's Hunger — Meals Are a Matter of Diligence, Not National Power",
    excerpt: "미국 대학생과 영국 아이의 끼니에서 출발해 21개국과 EU 정부의 결식·식비 대응을 점검했다. 세계 최상위 경제에서 끼니가 위태로운 것은 돈이 없어서가 아니라 제도의 선을 어디에 긋고 그 바깥을 얼마나 성실하게 돌보느냐의 문제다. 조건부 지원, 정치 주기, 자선 의존, 시장 구조, 측정 공백이라는 다섯 원인을 짚고, 보편·자동 안정·가격 구조·자급 기반을 하나로 묶은 '끼니 최저선 보장 체계'와 한국형 단계안을 제안한다. 게시 전 주요 주장 57건을 원 출처와 재검증한 원문 보고서를 함께 공개한다.",
    excerptEn: "Starting from the meals of American college students and British children, this column reviews how the governments of 21 countries and the EU respond to hunger and food costs. In the world's richest economies, meals are at risk not because money is lacking but because of where governments draw the lines of their programs and how faithfully they care for those outside them. It identifies five causes — conditional support, political cycles, reliance on charity, market structure and a measurement gap — and proposes a single 'minimum meal guarantee' framework combining universality, automatic stabilisers, price structure and domestic supply, with a phased plan for Korea. The source report, with 57 key claims re-verified against original sources before publication, is published alongside.",
    image: "/images/cards/r-015.svg",
    tone: "dark" as const,
    opinion: true, // ★ 오피니언 전용 칸 — 분석 5칸과 별도 (최신 1편 노출 → r-014는 오피니언 목록에 유지)
  },
  {
    id: "r-014",
    category: "오피니언 · 청해 칼럼",
    categoryEn: "Opinion · Cheonghae Column",
    date: "2026-10-08",
    author: "청해",
    title: "인류의 자원 이동의 역사와 석유 — 석유는 대체되지 않는다",
    titleEn: "Humanity's History of Resource Shifts and Oil — Why Oil Is Not Being Replaced",
    excerpt: "2026년 호르무즈 봉쇄에서 출발해 인류의 자원 대체사를 짚는다. 고래기름이 등유로 바뀌었듯 자원은 같은 범주의 더 나은 자원으로 대체되어 왔지만, 연료이자 소재인 석유는 연료 역할만 일부 내주며 소재 역할은 오히려 키우고 있다. 록펠러에서 호르무즈까지 힘은 생산만큼이나 유통 길목과 가격 결정 장소에서 나왔다. 관찰자의 정리와 필자의 규범적 판단을 분리해 싣고, 장별 재검증을 거친 원문 보고서를 함께 공개한다.",
    excerptEn: "Starting from the 2026 closure of the Strait of Hormuz, this column traces how humanity has replaced its resources. Whale oil gave way to kerosene: resources have been replaced by better resources of the same kind. Oil, both fuel and feedstock, is ceding only part of its fuel role while its role as a material grows. From Rockefeller to Hormuz, power has come as much from distribution chokepoints and price-setting venues as from production. The observer's summary and the author's normative view are presented separately, alongside the fully re-verified source report.",
    image: "/images/cards/r-014.svg",
    tone: "dark" as const,
    opinion: true, // ★ 오피니언 전용 칸 — 분석 5칸과 별도
  },
  {
    id: "r-013",
    category: "Λ¹² · 국가분석 총서",
    categoryEn: "Λ¹² · National Analysis Series",
    date: "2026-10-07",
    author: "김기섭",
    title: "국가분석 총서 7권 — 공리와 수식 · 권역별 국가 리포트",
    titleEn: "National Analysis Series, 7 Volumes — Axioms and Formulas · Regional Country Reports",
    excerpt: "국가분석 총서 7권 동시 발행. 제1권 「공리와 수식」은 Λ¹² 공리 A0~A12와 반증조건, 12차원 상태벡터, BSLI 4항식, F(t)>SE(t) 임계판정과 압박 좌표계 7공식, 시계열 판독법을 정리했다. 제2~7권은 권역별 198개국을 같은 형식으로 싣는다 — 인과루프도 v3.1 138개국(정본 생성기 무수정 출력), 2016~2024 궤적과 연간 변화량, 서사 브리핑 73개국. η×BSLI 상관 r=0.7551 재현. 판정과 예측 없이 현재 진행 방향까지만 적는다.",
    excerptEn: "Seven volumes of the National Analysis Series published together. Volume 1, \"Axioms and Formulas\", sets out axioms A0–A12 with falsification conditions, the 12-dimension state vector, the four-term BSLI formula, the F(t)>SE(t) threshold model, the seven pressure-coordinate formulas and how to read the time series. Volumes 2–7 cover 198 countries by region in one identical format — causal loop diagrams v3.1 for 138 countries (unmodified canonical generator output), 2016–2024 trajectories with annual changes, and narrative briefings for 73 countries. η×BSLI correlation r=0.7551 reproduced. No verdicts or forecasts: each report stops at the current direction.",
    image: "/images/cards/r-013.svg",
    tone: "dark" as const,
  },
  {
    id: "r-012",
    category: "REVERBANT · 관찰자 예측",
    categoryEn: "REVERBANT · Observer Forecast",
    date: "2026-09-29",
    author: "김기섭",
    title: "미국 2026 중간선거 예측 — 봉기가 아니라 선거로 압력을 방전 (관찰자 진단 v4.3)",
    titleEn: "US 2026 Midterm Forecast — Discharging Pressure Through the Ballot, Not the Barricade (Observer Diagnosis v4.3)",
    excerpt: "성숙 민주국이 봉기가 아니라 선거로 압력을 방전하는 제도의 작동. 12축 압박이 전부 생활압박축(경제·의료·제도신뢰)에 몰려 집권 공화당 역풍으로 정렬됐다. 하원은 민주 탈환 우세(중앙 226·D+11, Cook·Sabato 220~230 정합), 상원은 공화 사수 우세(약)이나 토스업 7곳에 민주도 살아있는 꼬리 — 가장 정합적 종점은 분점정부. 승인 ~39%(50% 미만)·집계 제너릭 D+7~8. 제미나이·ChatGPT 외부 검수와 자체 적대적 감사를 반영, §12에 반증 조건 5항을 명시해 '실패가 아니라 관측' 도피구를 제거했다.",
    excerptEn: "A mature democracy discharging pressure through the ballot, not the barricade. All 12 axes of pressure cluster on the livelihood axes (economy, healthcare, institutional trust), aligning as a headwind against the incumbent GOP. The House favors a Democratic recapture (central 226, D+11, consistent with Cook/Sabato 220–230); the Senate favors a weak GOP hold, yet with seven toss-ups the Democrats keep a live tail — the most consistent endpoint is divided government. Approval ~39% (below 50%); aggregate generic ballot D+7–8. Reflecting external reviews (Gemini, ChatGPT) and an internal adversarial audit, §12 now states five explicit falsification triggers, removing the 'observation, not failure' escape hatch.",
    image: "/images/cards/r-012.svg",
    tone: "dark" as const,
  },
  {
    id: "r-011",
    category: "UI · 봉기지수 · 실측",
    categoryEn: "UI · Uprising Index · Measured",
    date: "2026-09-27",
    author: "김기섭",
    title: "에티오피아 봉기 벡터 재분석 — 인과좌표계 실측 · 밴드 6축과 생존동맹",
    titleEn: "Ethiopia Uprising-Vector Reanalysis — Measured Causal Coordinate, Six-Axis Band and the Alliance for Survival",
    excerpt: "giseu 궤적 실측으로 확정한 첫 아프리카 봉기 벡터보고서. 기저 중심 BSLI −0.8096(E·121위), η 0.4591(143위), 임계밴드 내 6축[A1·A2·A5·A6·A7·A8]·ΣP 4.309로 봉기 4국 공통조건 A7·A8 충족 — 표본 최다 하중. 단 흡수체 A8·압력원 A7이 완화 방향이라 급락형이 아닌 만성 하중형. 2026.9 7세력 생존동맹 결성 배경 포함.",
    excerptEn: "The first African uprising-vector report fixed on measured giseu trajectories. Base-center BSLI −0.8096 (E, 121st), η 0.4591 (143rd), six axes in the critical band [A1·A2·A5·A6·A7·A8] with ΣP 4.309 — meeting the four-uprising common condition A7·A8, the heaviest load in the sample. Yet with absorber A8 and pressor A7 easing, it reads as chronic load, not a sharp-drop signature. Includes the September 2026 seven-force Alliance for Survival.",
    image: "/images/cards/r-011.svg",
    tone: "dark" as const,
  },
  {
    id: "r-007",
    category: "Λ¹²v2.0 · BSLIv6.9 · 글로벌 전수",
    categoryEn: "Λ¹²v2.0 · BSLIv6.9 · Global Full Coverage",
    date: "2026-07-18",
    author: "김기섭",
    title: "Λ¹²·BSLI 통합 국가분석 — 138국 전수 산출 2026",
    titleEn: "Λ¹²·BSLI Joint National Analysis — 138 Countries Full Report 2026",
    excerpt: "η·BSLI 138국 전수 산출. Pearson r=0.7551 강한 양의 상관 확인. HH 안정번영 51국 / HL 민생위기 18국 / LH 민생선행 18국 / LL 이중취약 51국. 한국 HH·인도네시아 HL 확정.",
    excerptEn: "Full computation for 138 countries. Pearson r=0.7551 strong positive correlation confirmed. HH Stable Prosperity 51 / HL Livelihood Crisis 18 / LH Livelihood-Led 18 / LL Dual Vulnerability 51. Korea HH · Indonesia HL confirmed.",
    image: "/images/cards/r-007.svg",
    tone: "light" as const,
    pinned: true, // ★ 상단 고정 — 통합 국가분석 정본. 버전업 시 이 항목만 수정.
  },
  {
    id: "r-009",
    category: "BSLI v7.0 · 시계열 정본",
    categoryEn: "BSLI v7.0 · Canonical Time Series",
    date: "2026-07-26",
    author: "김기섭",
    title: "BSLI 2026 상반기 정본 — 137개국 기초사회생활지수 시계열 (2016–2024)",
    titleEn: "BSLI 2026 H1 Canon — Basic Social Life Index Time Series, 137 Countries (2016–2024)",
    excerpt: "서민층(소득 30~50분위) 衣食住 기층 압박을 137개국 × 2016–2024년, 1,002셀 시계열로 구축한 상반기 정본. 정본 대조 r=0.976 · F_ML 정합 r=0.988. 등급분포 A/B 22 · C 10 · D 16 · E 89 — 다수 국가가 기본생활선(0) 아래에 머문다. 국가별 2016→2024 궤적 스파크라인 수록.",
    excerptEn: "The first-half canon: food/housing pressure on the 30th–50th income percentiles across 137 countries × 2016–2024, 1,002 cells. Canon correlation r=0.976 · F_ML consistency r=0.988. Grades A/B 22 · C 10 · D 16 · E 89 — most countries remain below the basic-living line (0). Includes per-country 2016→2024 sparkline trajectories.",
    image: "/images/cards/r-009.svg",
    tone: "light" as const,
    pinned: true, // ★ 상단 고정 — BSLI 시계열 정본. 하반기판 나오면 이 항목을 갱신(신규 추가 금지).
  },
  // r-008 (봉기 코호트 구독판 4부작) — 2026-10-08 청해 지시로 홈 최신분석에서만 제외(국가분석 총서 r-013 게시에 따른 최고령 카드).
  //   보고서 자체는 /reports/r-008 직접 링크 + 카테고리에 그대로 유지.
  // r-006 (인도네시아 봉기경로 진단) — 2026-09-29 청해 지시로 홈 최신분석에서만 제외.
  //   보고서 자체는 /reports/r-006 직접 링크 + cat-ui(봉기지수) 카테고리에 그대로 유지.
  {
    id: "r-004",
    category: "UI · 봉기지수",
    categoryEn: "UI · Uprising Index",
    date: "2026-07-12",
    author: "김기섭",
    title: "압력은 왜 반발이 아닌 희망이 되었나 — 베네수엘라·이란 2026",
    titleEn: "Why Pressure Became Hope, Not Backlash — Venezuela & Iran 2026",
    excerpt: "지도자를 빼앗긴 국가와 학살로 버틴 국가. 희망 벡터 역전, 기대-배신 격차 G(t), 그리고 역사 표본 11건이 가리키는 외생 버팀목 체제의 세 가지 종점.",
    excerptEn: "A state whose leader was seized and a state that survived by massacre. Hope-vector inversion, the expectation-betrayal gap G(t), and the three historical endpoints of externally propped regimes.",
    image: "/images/cards/r-004.svg",
    tone: "dark" as const,
  },
  {
    id: "r-001",
    category: "REVERBANT · 글로벌 실증",
    categoryEn: "REVERBANT · Global Validation",
    date: "2026-07-03",
    author: "김기섭",
    title: "965,913건의 데이터가 말하는 것 — 봉기는 어떻게 시작되는가",
    titleEn: "What 965,913 Data Points Tell Us — How Uprisings Begin",
    excerpt: "ACLED 전역 데이터와 REVERBANT v1.1 프레임워크의 완전 통합. 공리 A0~A12가 실증하는 도화선·화약·폭발의 물리학.",
    excerptEn: "Full integration of ACLED global data with REVERBANT v1.1. Axioms A0–A12 demonstrate the physics of trigger, powder, and explosion.",
    image: "/images/cards/r-001.svg",
    tone: "dark" as const,
  },
];

/* ── 파생 목록 (수동 관리 불필요) ─────────────────────────────────────────── */

/** date 문자열(YYYY-MM-DD) 내림차순 — 사전순 비교로 충분한 고정 포맷 */
const byDateDesc = (a: FeaturedReport, b: FeaturedReport) =>
  a.date < b.date ? 1 : a.date > b.date ? -1 : 0;

/**
 * 홈 최신분석 섹션이 실제로 렌더링하는 목록.
 * 고정(pinned) 항목이 먼저, 그 아래 나머지가 날짜 내림차순.
 * 총 FEATURED_MAX개를 넘으면 가장 오래된 항목부터 자동으로 노출에서 제외된다.
 * (filter가 새 배열을 만들므로 sort가 원본 featuredReports를 훼손하지 않는다.)
 */
export const featuredReportsVisible: FeaturedReport[] = [
  ...[
    ...featuredReports.filter((r) => !r.opinion && r.pinned).sort(byDateDesc),
    ...featuredReports.filter((r) => !r.opinion && !r.pinned).sort(byDateDesc),
  ].slice(0, FEATURED_MAX),
  // 오피니언 전용 칸 — 분석 5칸과 별도로 맨 아래에 최신 칼럼 FEATURED_OPINION_MAX편
  ...featuredReports.filter((r) => r.opinion).sort(byDateDesc).slice(0, FEATURED_OPINION_MAX),
];

/** 노출 목록 중 가장 최근 날짜 (고정 항목 포함) — 섹션 헤더 스탬프용 */
export const featuredLatestDate: string =
  [...featuredReportsVisible].sort(byDateDesc)[0]?.date ?? "";

/** 섹션 헤더 스탬프 예: "2026.07 · 05" (최신 연·월 · 노출 카드 수) */
export const featuredStamp: string = (() => {
  const [y, m] = featuredLatestDate.split("-");
  const count = String(featuredReportsVisible.length).padStart(2, "0");
  return y && m ? `${y}.${m} · ${count}` : count;
})();

export const mainCategories = [
  {
    id: "cat-national",
    label: "국가 분석 보고서",
    labelEn: "National Analysis",
    engineKey: "lambda",
    engineLabel: "Λ¹²",
    count: 156,
    subFilters: ["전체", "권역별", "단독"],
    subFiltersEn: ["All", "Regional", "Standalone"],
    topics: ["지정학", "정치", "경제", "사회"],
    topicsEn: ["Geopolitics", "Politics", "Economy", "Society"],
    isCore: true,
    image: "https://readdy.ai/api/search-image?query=Aerial%20drone%20photography%20of%20modern%20global%20capital%20city%20skyline%20at%20golden%20hour&width=800&height=600&seq=cat-national-01&orientation=landscape",
  },
  {
    id: "cat-bsli",
    label: "기초사회생활지수",
    labelEn: "Basic Social Life Index",
    engineKey: "bsli",
    engineLabel: "BSLI",
    count: 203,
    subFilters: ["전체", "권역별", "단독"],
    subFiltersEn: ["All", "Regional", "Standalone"],
    topics: ["의(衣)", "식(食)", "주(住)"],
    topicsEn: ["Clothing", "Food", "Housing"],
    isCore: true,
    image: "https://readdy.ai/api/search-image?query=Street%20level%20candid%20photography%20of%20diverse%20urban%20residents%20daily%20life&width=800&height=600&seq=cat-bsli-02&orientation=landscape",
  },
  {
    id: "cat-reverbant",
    label: "리버번트",
    labelEn: "REVERBANT",
    engineKey: "reverbant",
    engineLabel: "REVERBANT",
    count: 89,
    subFilters: ["전체", "권역별", "단독"],
    subFiltersEn: ["All", "Regional", "Standalone"],
    topics: ["섭동", "반응", "회복", "임계"],
    topicsEn: ["Perturbation", "Response", "Recovery", "Threshold"],
    isCore: true,
    image: "https://readdy.ai/api/search-image?query=Abstract%20scientific%20visualization%20wave%20patterns%20interference%20dynamics&width=800&height=600&seq=cat-reverbant-03&orientation=landscape",
  },
  {
    id: "cat-ui",
    label: "봉기지수",
    labelEn: "Uprising Index",
    engineKey: "ui",
    engineLabel: "UI",
    count: 74,
    subFilters: ["전체", "권역별", "단독"],
    subFiltersEn: ["All", "Regional", "Standalone"],
    topics: ["민중", "제도", "촉발", "임계"],
    topicsEn: ["People", "Institution", "Trigger", "Threshold"],
    isCore: true,
    image: "https://readdy.ai/api/search-image?query=Wide%20angle%20documentary%20photograph%20peaceful%20public%20demonstration%20historic%20city%20square&width=800&height=600&seq=cat-ui-04&orientation=landscape",
  },
  {
    id: "cat-bbd",
    label: "버블붕괴탐지기",
    labelEn: "Bubble & Burst Detector",
    engineKey: "bbd",
    engineLabel: "§33 BBD",
    count: 38,
    subFilters: ["전체", "권역별", "단독"],
    subFiltersEn: ["All", "Regional", "Standalone"],
    topics: ["버블", "붕괴", "주기"],
    topicsEn: ["Bubble", "Collapse", "Cycle"],
    isCore: false,
    image: "https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?w=800&q=80",
  },
  {
    // 2026-10-25 청해: 불필요하여 삭제(공식 통계로 언제든 얻을 수 있는 수치) — 섹션 카드만 비워 둔다
    id: "cat-gei",
    label: "지니경제불평등지수",
    labelEn: "Gini Economic Inequality Index",
    engineKey: "gei",
    engineLabel: "§34 GEI",
    count: 0,
    subFilters: ["전체", "권역별", "단독"],
    subFiltersEn: ["All", "Regional", "Standalone"],
    topics: ["2026-10-25 불필요하여 삭제"],
    topicsEn: ["Removed 2026-10-25 as unnecessary"],
    isCore: false,
    image: "https://readdy.ai/api/search-image?query=Atmospheric%20post%20industrial%20landscape%20abandoned%20factory&width=800&height=600&seq=cat-gei-06&orientation=landscape",
  },
  {
    id: "cat-nci",
    label: "국가역량지수",
    labelEn: "National Capacity Index",
    engineKey: "nci",
    engineLabel: "§35 NCI",
    count: 29,
    subFilters: ["전체", "권역별", "단독"],
    subFiltersEn: ["All", "Regional", "Standalone"],
    topics: ["국가역량", "제도", "위기"],
    topicsEn: ["State Capacity", "Institution", "Crisis"],
    isCore: false,
    image: "https://readdy.ai/api/search-image?query=Nuclear%20power%20plant%20cooling%20towers%20storm%20clouds&width=800&height=600&seq=cat-nci-07&orientation=landscape",
  },
  {
    id: "cat-scdi",
    label: "공급망교란지수",
    labelEn: "Supply Chain Disruption Index",
    engineKey: "scdi",
    engineLabel: "§36 SCDI",
    count: 33,
    subFilters: ["전체", "권역별", "단독"],
    subFiltersEn: ["All", "Regional", "Standalone"],
    topics: ["공급망", "무역", "지정학"],
    topicsEn: ["Supply Chain", "Trade", "Geopolitics"],
    isCore: false,
    image: "https://readdy.ai/api/search-image?query=Aerial%20view%20container%20port%20terminal%20shipping&width=800&height=600&seq=cat-scdi-08&orientation=landscape",
  },
  {
    id: "cat-ppi",
    label: "권력기생지수",
    labelEn: "Power Parasite Index",
    engineKey: "ppi",
    engineLabel: "§37 PPI",
    count: 51,
    subFilters: ["전체", "권역별", "단독"],
    subFiltersEn: ["All", "Regional", "Standalone"],
    topics: ["권력기생", "포획", "책임"],
    topicsEn: ["Power Parasite", "Capture", "Accountability"],
    isCore: false,
    image: "https://readdy.ai/api/search-image?query=Government%20institutional%20building%20classical%20columns%20authority&width=800&height=600&seq=cat-ppi-09&orientation=landscape",
  },
  {
    id: "cat-press",
    label: "언론 브리핑룸",
    labelEn: "Press Briefing Room",
    engineKey: "",
    engineLabel: "PRESS",
    count: 0,
    subFilters: ["전체", "국내", "해외", "분석"],
    subFiltersEn: ["All", "Domestic", "Global", "Analysis"],
    topics: ["정치", "경제", "사회", "국제"],
    topicsEn: ["Politics", "Economy", "Society", "International"],
    isCore: false,
    image: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=800&q=80",
  },
  {
    id: "cat-axioms",
    label: "사회구조 설계공리",
    labelEn: "Social Structure Design Axioms",
    engineKey: "axioms",
    engineLabel: "A0—A12",
    count: 13,
    subFilters: [],
    subFiltersEn: [],
    topics: [],
    topicsEn: [],
    isCore: false,
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80",
  },
  {
    id: "cat-opinion",
    label: "오피니언",
    labelEn: "Opinion",
    engineKey: "",
    engineLabel: "OPINION",
    count: 0,
    subFilters: [],
    subFiltersEn: [],
    topics: [],
    topicsEn: [],
    isCore: false,
    image: "/images/cards/cat-opinion.svg",
  },
];

export const aboutImages = {
  left: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=900&q=80",
  right:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1400&q=80",
};

export const testimonials = [
  {
    quote:
      "숫자 뒤에 숨은 사회의 결을 읽어내는 방식이 남다릅니다. 정책 기획 회의에서 매번 인용하는 리포트예요.",
    name: "정하늘",
    role: "국책 연구원 · 사회정책실",
    rating: 4.9,
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20photograph%20of%20professional%20Korean%20woman%20in%20her%20forties%20wearing%20cream%20turtleneck%20sweater%20with%20soft%20natural%20window%20light%2C%20muted%20warm%20background%2C%20magazine%20quality%20portrait%20photography%2C%20confident%20warm%20expression&width=200&height=200&seq=avatar-jung-01&orientation=squarish",
  },
  {
    quote:
      "차트 하나에도 방법론과 원출처가 다 명시되어 있어서 뉴스룸에서 바로 인용할 수 있습니다.",
    name: "윤태오",
    role: "경제 일간지 · 데이터저널리즘팀 리드",
    rating: 5.0,
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20photograph%20of%20professional%20Korean%20man%20in%20his%20thirties%20wearing%20forest%20green%20shirt%20with%20soft%20natural%20window%20light%2C%20muted%20cream%20background%2C%20magazine%20quality%20portrait%20photography%2C%20thoughtful%20confident%20expression&width=200&height=200&seq=avatar-yoon-02&orientation=squarish",
  },
  {
    quote:
      "전략 리포트 작성 시간이 절반으로 줄었어요. 데이터 큐레이션 품질이 압도적입니다.",
    name: "Sarah Kim",
    role: "글로벌 컨설팅 · 리서치 매니저",
    rating: 4.8,
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20photograph%20of%20professional%20Asian%20woman%20in%20her%20thirties%20with%20short%20hair%20wearing%20cream%20blazer%20in%20soft%20natural%20light%2C%20muted%20warm%20neutral%20background%2C%20high%20end%20magazine%20portrait%20photography%2C%20warm%20confident%20expression&width=200&height=200&seq=avatar-sarah-03&orientation=squarish",
  },
];

export const partners = [
  "ACLED",
  "SSRN",
  "World Bank",
  "UN Stats",
  "Eurostat",
  "IMF",
  "한국은행",
];
